export const DSCORE_OAUTH_STATE_KEY = "dscore_state";
export const DSCORE_OAUTH_CODE_VERIFIER_KEY = "dscore_code_verifier";
